export default {
  name_ja: `<b>全角125文字以内 もしくは 半角英数字250文字以内</b><br>
    単語間には半角スペースを入力します。<br>
    正しい例: 山田 太郎 / Taro Yamada<br>
    <br>
    大文字と小文字は区別されます。<br>
    例: Music と music<br>
    <br>
    ハイフンなどの記号は区分されます。<br>
    例: Mu sic と Mu-sic など<br>
    <br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    変換例: MUSIC → Music<br>
    <br>
    以下は入力NGです。<br>
    ・‎スティーヴン・タイラー フロム エアロスミス[グループ名が含まれる]<br>
    ・ジョー（ギター）[役割が含まれる]<br>
    ・山田 太郎 ＆ マイケル [複数名が含まれる]<br>
    ・絵文字などの特殊文字<br>
    ・総称的な名称（一般名詞、楽器名、ジャンル名）<br>
    ・山田 太郎 （TARO YAMADA）[翻訳表記が含まれる] <br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  name_kana: `<b>全角カナ70文字以内</b><br>
    半角、全角スペースは使用できません。<br>
    <br>
    以下は入力NGです。<br>
    ・‎スティーヴンタイラーフロムエアロスミス[グループ名が含まれる]<br>
    ・ジョーギター[役割が含まれる]<br>
    ・ヤマダタロウマイケル [複数名が含まれる]<br>
    ・絵文字などの特殊文字<br>
    ・総称的な名称（一般名詞、楽器名、ジャンル名）<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  name_en: `<b>半角英数字250文字以内</b><br>
    <br>
    単語間には半角スペースを入力します。(名/性)<br>
    正しい例: Taro Yamada<br>
    <br>
    大文字と小文字は区別されます。<br>
    例: Music と music<br>
    <br>
    ハイフンなどの記号は区分されます。<br>
    例: Mu sic と Mu-sic など<br>
    <br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    変換例: MUSIC → Music<br>
    <br>
    以下は入力NGです<br>
    ・Steven Tyler from Aerosmith[グループ名が含まれる]<br>
    ・Joe(Gt)[役割が含まれる]<br>
    ・Taro Yamada & Michael [複数名が含まれる]<br>
    ・絵文字などの特殊文字<br>
    ・総称的な名称（一般名詞、楽器名、ジャンル名）<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br>
    <br>
    アルファベット表記の例<br>
    タイトル:山田 太郎<br>
    アルファベット表記:Taro Yamada<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br>
    <br>`,
  image: `<b>・JPG または PNG イメージファイル</b><br>
    ・最高品質のRGB カラーモード (白黒含む) 注：CMYK は使用できません<br>
    ・20M以内<br>
    ・アーティスト画像の登録は1枚のみ`,
  artistImage: `<b>・JPGイメージファイル</b><br>
  ・5120 × 5120 ピクセル以上の正方形 （6000 × 6000まで）<br>
  ・最高品質のRGB カラーモード (白黒含む) 注：CMYK は使用できません<br>
  ・6MB以内 <br>
  ・アーティスト画像の登録は1枚のみ <br>
  ・拡大したイメージは不可`,
  spotifyCover: `<b>・JPGイメージファイル</b><br>
  ・2660 × 1140 ピクセル以上の長方形 <br>
  ・最高品質のRGB カラーモード (白黒含む) 注：CMYK は使用できません<br>
  ・6MB以内 <br>`,
}
